import { PropsWithChildren } from "react";
import { Outlet } from "react-router";

import { Footer } from "./footer";
import { Header } from "./header";

export const Layout = ({ children }: PropsWithChildren) => {
  return (
    <>
      <Header />
      {children ?? <Outlet />}
      <Footer />
    </>
  );
};
